export default __webpack_public_path__ + "static/media/venmo_qr.ec8f17e6.svg";